import { CssBaseline, ThemeProvider } from '@mui/material';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './components';
import * as Sentry from '@sentry/react';

import { flexTheme } from '@flex/flex-ui';

import '@fontsource/heebo/300.css';
import '@fontsource/heebo/400.css';
import '@fontsource/heebo/500.css';
import '@fontsource/heebo/700.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			refetchOnWindowFocus: false,
			suspense: true,
			onError: (error: unknown): void => {
				console.error(error);
			},
		},
	},
});

Sentry.init({
	dsn: 'https://7b3e216f8a6cb2f8d6e1ea5172130ab5@o1132973.ingest.us.sentry.io/4509276887842817',
	environment: import.meta.env.PROD ? 'production' : 'development',
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ThemeProvider theme={flexTheme}>
				<CssBaseline />
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</ThemeProvider>
		</QueryClientProvider>
	</StrictMode>
);
